module.exports = "/legacy/e0db9fdf48ec7b6e63b65d2404e4e91d.svg";